/**
 * Fetch user details from Auth0 using the Management API.
 * @param {string} userId - The Auth0 user ID (e.g., "auth0|67ac8dfa33fc24a5487a0bc5")
 */
export const getUserDetails = async (token,userId) => {
    try {
        const userResponse = await fetch(`/api/user/${userId}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!userResponse.ok) throw new Error("Failed to fetch user details");
        const userData = await userResponse.json();


        // Return user details along with permissions
        return {
            ...userData,
            permissions: userData.permissions.map((perm) => perm.permission_name), // Extract only permission names
        };
    } catch (error) {
        console.error("Error fetching user details:", error);
        return null;
    }
};
export const getUsersDb = async (token) => {
    try {

        const response = await fetch(`/api/users`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) throw new Error("Failed to fetch user details");

        return await response.json();
    } catch (error) {
        console.error("Error fetching user details:", error);
        return null;
    }
};

export const getAllDevices = async (token) => {
    try{
        const response = await fetch(`/api/devices/all`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            }
        });
        if (!response.ok) throw new Error("Failed to fetch devices");
        return await response.json();
    }catch (error) {
        console.error("Error fetching user details:", error);
        return null;
    }
};